import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogProps } from '@expressable/syntax-ds';

type Props = DialogProps & {
  code: string | null;
  onConfirm: () => void;
};

export const DirectSignupPreBookNoLongerAvailableDialog = ({ code, onConfirm, ...dialogProps }: Props) => {
  const { t } = useTranslation();

  const getTitleKey = () => {
    return code === 'BOTH_SESSIONS_UNAVAILABLE'
      ? 'signup.direct.steps.prebook.conflicts.title'
      : 'signup.direct.steps.prebook.conflict.title';
  };

  const getBodyKey = () => {
    switch (code) {
      case 'BOTH_SESSIONS_UNAVAILABLE':
        return 'signup.direct.steps.prebook.conflicts.bothSessions';
      case 'FIRST_SESSION_UNAVAILABLE':
        return 'signup.direct.steps.prebook.conflicts.firstSession';
      case 'SECOND_SESSION_UNAVAILABLE':
        return 'signup.direct.steps.prebook.conflicts.secondSession';
      default:
        return 'signup.direct.steps.prebook.conflicts.firstSession';
    }
  };

  return (
    <Dialog {...dialogProps}>
      <div className="space-y-8">
        <Dialog.Title>{t(getTitleKey())}</Dialog.Title>
        <Dialog.Body>{t(getBodyKey())}</Dialog.Body>
      </div>
      <Dialog.CTAs>
        <Button onClick={onConfirm}>{t(`directSignup.dialogs.noLongerAvailable.prebook.confirm`)}</Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
